var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetsbloomLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278.623,
    height: 59.519,
    viewBox: "0 0 278.623 59.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.118,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ba455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3abe36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ea00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.025,
    y1: 0.823,
    x2: 0.987,
    y2: 0.169,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.199,
    y1: 1.375,
    x2: 0.801,
    y2: -0.375,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ffdc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.562,
    y1: 0.534,
    x2: 0.87,
    y2: 0.081,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0417ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0da7ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.041,
    y1: 0.907,
    x2: 0.996,
    y2: -0.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff6d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ff2100"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "montserrat_regular_sz60.65_-74va",
    "data-name": "montserrat regular sz60.65 -74va",
    transform: "translate(0 47.519)",
    fill: "#fff",
    fontSize: 49,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "-0.07em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "letsbloom")), /*#__PURE__*/React.createElement("g", {
    id: "inverted",
    transform: "translate(225.77)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_1",
    "data-name": 1,
    cx: 11.06,
    cy: 24.247,
    rx: 11.06,
    ry: 24.247,
    transform: "translate(1.454)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3",
    "data-name": 3,
    d: "M281.79,46.925c.618-5.472,8.588-12.157,19.574-15.939,12.659-4.36,24.536-3.214,26.522,2.563s-6.659,14.011-19.319,18.346c-10.714,3.684-20.81,3.437-24.906-.2",
    transform: "translate(-275.317 -4.983)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "_2",
    "data-name": 2,
    cx: 24.247,
    cy: 11.06,
    rx: 24.247,
    ry: 11.06,
    transform: "matrix(0.581, -0.814, 0.814, 0.581, 0, 40.833)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle_left",
    "data-name": "middle left",
    d: "M289.354,23.713c-7.483,10.492-9.89,21.742-5.6,25.722a6.707,6.707,0,0,0,.684.536,7,7,0,0,0,5.6.635c5.027-2.283,8.81-12.049,8.81-23.744A48,48,0,0,0,297.4,14.87,48.3,48.3,0,0,0,289.354,23.713Z",
    transform: "translate(-275.29 -2.615)",
    opacity: 0.77,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle_right",
    "data-name": "middle right",
    d: "M301.361,31.01c-11.168,3.841-19.211,10.714-19.591,16.211a7.228,7.228,0,0,0,2.06,4.648,8.244,8.244,0,0,0,1.129.775c5.176,2.662,14.983-3.239,22.442-13.7a47.974,47.974,0,0,0,5.769-10.467,47.917,47.917,0,0,0-11.81,2.53Z",
    transform: "translate(-275.314 -5.008)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "center",
    d: "M298.814,32.7C289,36.648,282.133,42.837,281.77,47.947v.107a1.321,1.321,0,0,0,.074.536c.074.173,0,.124,0,.181l.1.486.049.19a1.358,1.358,0,0,0,.132.429,2.126,2.126,0,0,0,.066.214c.041.124.091.247.14.371l.1.223a2.214,2.214,0,0,0,.157.313c0,.082.074.157.115.239a2.71,2.71,0,0,0,.165.256c.049.082.1.165.157.247l.14.173a5.1,5.1,0,0,0,.478.552l.115.115.321.255a7.743,7.743,0,0,0,.717.478l.173.107.165.066a3.626,3.626,0,0,0,.412.173l.2.066.412.115.206.049a4.449,4.449,0,0,0,.478.074H287a6.034,6.034,0,0,0,.668,0h.923l.511-.066h.239a2.541,2.541,0,0,0,.544-.107h.157C294.718,51.623,298.286,43.167,298.814,32.7Z",
    transform: "translate(-275.314 -5.75)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsbloomLogo);
export default __webpack_public_path__ + "static/media/letsbloom_logo.30afa9da64e5b184754f38f912310e1f.svg";
export { ForwardRef as ReactComponent };